export default __webpack_public_path__ + "static/media/cardano.8169bf45.png";